var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuAmministrazione(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-amministrazione") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-amministrazione"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12 C0,18.6272846 5.37253977,24 12.0001132,24 C18.6274602,24 24,18.6272846 24,12 C24,5.37271544 18.6274602,0 12.0001132,0 C5.37253977,0 0,5.37271544 0,12",
    id: "Fill-1",
    fill: "#009846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7249999,5 L6,7.5444444 L6,11.361111 C6,14.8915276 8.44266663,18.1929442 11.7249999,18.9944442 C15.0073332,18.1929442 17.4499998,14.8915276 17.4499998,11.361111 L17.4499998,7.5444444 L11.7249999,5 Z M10.4527777,15.1777776 L7.9083333,12.6333332 L8.80524995,11.7364166 L10.4527777,13.3775832 L14.6447499,9.18561104 L15.5416665,10.0888888 L10.4527777,15.1777776 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAmministrazione);
export default __webpack_public_path__ + "static/media/menu-amministrazione.981f8fd371990b2625bb277f75b49e17.svg";
export { ForwardRef as ReactComponent };